//#region theme/frontend/islands/cursor-badge.js
var EASE = "120ms ease-in-out";
var CursorBadge = class CursorBadge extends HTMLElement {
	connectedCallback() {
		this.area = this.parentElement;
		this.arrow = this.querySelector("[data-arrow]");
		this.label = this.querySelector("[data-label]");
		this._active = false;
		if (this.arrow) {
			this._arrowSize = this.arrow.offsetHeight + "px";
			this.arrow.style.width = "0";
			this.arrow.style.padding = "0";
		}
		if (!CursorBadge._tracking) {
			CursorBadge._tracking = true;
			document.addEventListener("mousemove", (e) => {
				CursorBadge._cx = e.clientX;
				CursorBadge._cy = e.clientY;
			}, {
				passive: true,
				capture: true
			});
		}
		this._move = () => this._update();
		this._scroll = () => this._update();
		this._leave = () => {
			if (this._active) this._hide();
		};
		this.area.addEventListener("mousemove", this._move);
		this.area.addEventListener("mouseleave", this._leave);
		window.addEventListener("scroll", this._scroll, { passive: true });
	}
	_update() {
		const cx = CursorBadge._cx;
		const cy = CursorBadge._cy;
		if (cx == null) return;
		const r = this.area.getBoundingClientRect();
		const inside = cx >= r.left && cx <= r.right && cy >= r.top && cy <= r.bottom;
		if (inside && !this._active) this._show();
		else if (!inside && this._active) this._hide();
		if (!inside) return;
		const bw = this.offsetWidth;
		const bh = this.offsetHeight;
		let x = cx + 20;
		let y = cy - bh / 2;
		x = Math.max(r.left, Math.min(x, r.right - bw));
		y = Math.max(r.top, Math.min(y, r.bottom - bh));
		this.style.transform = `translate(${x}px,${y}px)`;
	}
	_show() {
		this._active = true;
		this.arrow.style.transition = `width ${EASE}, padding ${EASE}, opacity ${EASE}`;
		this.arrow.style.width = this._arrowSize;
		this.arrow.style.padding = "0.25rem";
		this.arrow.style.opacity = "1";
		this.label.style.transition = `max-width ${EASE}, padding ${EASE}, margin ${EASE}, opacity ${EASE}`;
		this.label.style.maxWidth = "200px";
		this.label.style.padding = "0.25rem 0.375rem";
		this.label.style.marginRight = "2px";
		this.label.style.opacity = "1";
	}
	_hide() {
		this._active = false;
		this.arrow.style.transition = `width ${EASE}, padding ${EASE}, opacity ${EASE}`;
		this.arrow.style.width = "0";
		this.arrow.style.padding = "0";
		this.arrow.style.opacity = "0";
		this.label.style.transition = `max-width ${EASE}, padding ${EASE}, margin ${EASE}, opacity ${EASE}`;
		this.label.style.maxWidth = "0";
		this.label.style.padding = "0.25rem 0";
		this.label.style.marginRight = "0";
		this.label.style.opacity = "0";
	}
	disconnectedCallback() {
		if (!this.area) return;
		this.area.removeEventListener("mousemove", this._move);
		this.area.removeEventListener("mouseleave", this._leave);
		window.removeEventListener("scroll", this._scroll);
	}
};
CursorBadge._cx = null;
CursorBadge._cy = null;
CursorBadge._tracking = false;
customElements.define("cursor-badge", CursorBadge);
//#endregion
